import { AssetType } from '@seek/brand-types';
import type {
  UpdateExistingAsset,
  UploadNewAsset,
} from '@seek/image-service-types';
import setDebug from 'debug';

import { patchAsset } from './methods/patchAsset';
import { uploadAsset } from './methods/uploadAsset';

const debug = setDebug('image-service-uploader');

// =================================================================
// New uploads
// =================================================================

export const uploadNewCover: UploadNewAsset = async ({ file, croppedInfo }) => {
  const response = await uploadAsset({
    type: AssetType.COVER,
    file,
    croppedInfo,
  });

  debug(`${file.name} uploaded; available at ${response.url}`);
  return response;
};

// =================================================================
// Existing updates
// =================================================================

export const updateExistingLogo: UpdateExistingAsset = async ({ id }) => {
  const response = await patchAsset({ type: AssetType.LOGO, id });

  debug(`${id} updated; available at ${response.url}`);
  return response;
};

export const updateExistingCover: UpdateExistingAsset = async ({
  id,
  croppedInfo,
}) => {
  const response = await patchAsset({ type: AssetType.COVER, id, croppedInfo });

  debug(`${id} updated; available at ${response.url}`);
  return response;
};
